"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdminEmail = isAdminEmail;
exports.isAdminUser = isAdminUser;
function isAdminEmail(email) {
    // This regex must match:
    // `isLoggedInAsAdminUser` in `firestore/src/firestore.ward`
    // `isLoggedInAsAdminUser` in `storage.rules`
    return !!email.match(/^(alex|tom|eyal|chet|sam|sam[.]lee|james|sharan|guy)@clockwork[.]dog$/);
}
function isAdminUser(user) {
    var _a;
    return !user.disabled && user.emailVerified && isAdminEmail((_a = user.email) !== null && _a !== void 0 ? _a : '');
}
//# sourceMappingURL=users.js.map